import { TFormSchema, TGridSchema } from "@/comn/hooks";
import { ptlEnvs } from "@/tz/go/egaz/osci/ptl/comn";
import { api } from "@/comn";
import { comnUtils } from "@/comn/utils";

/*
 * Role Management Service
 * !== 역할 관리 Service ==!
 */

/*
 * @ BASE
 * @ 서비스에서 사용하는 기본 정보 세팅
 * @ path : 화면들의 기본 웹 경로
 * @ api : 사용하는 api 의 기본 주소
 * @ api 주소가 여러개일 경우 _ 로구분하여 의미에 맞게 카멜표기업으로 표시 : api_clr
 * @ nodes : 화면의 Page.Navigation 에서 사용하는 기본 결로 Array
 */
export const BASE = {
    path: `${ptlEnvs.base}/ptl/org-role`,
    api: `${process.env.REACT_APP_API_PTL_COMN}/api/v1/osci/ptl/ptl/role/org-role`,
};

/*
 * @ URLS
 * @ 화면에서 사용하는 주소들 정의
 * @ 해당화면의 컴포넌트명 대문자로 정의
 */
export const URLS = {
    osci0104025q: `${BASE.path}/osci0104025q`,
    osci0104026s: `${BASE.path}/osci0104026s`,
    osci0104027q: `${BASE.path}/osci0104027q`,
};

/*
 * @ APIS
 * @ 화면에서 사용하는 api 정의
 */
export const APIS = {
    getOgaUsrList: (data: any, page: number, size: number) =>
        api.get(`${BASE.api}/oga-usr?page=${page}&size=${size}`, { params: comnUtils.toGetParams(data) }),
    getOgaUsrInfo: (data: any) => api.get(`${BASE.api}/oga-auth/${data.usrIdntfId}`),
    getRoleList: (data: any, page: number, size: number) =>
        api.get(`${BASE.api}/role?page=${page}&size=${size}`, { params: comnUtils.toGetParams(data) }),
    saveOgaUsrRoleList: (data: any) => api.post(`${BASE.api}`, data),
    // Get a excel list of Customs staff. !== 세관 직원 엑셀 목록을 조회한다. ==!
    getOgaUsrExcelList: (data: any) => api.get(`${BASE.api}/oga-usr/excel`, { params: comnUtils.toGetParams(data) }),
};

export const SF_OGA_USR_SRCH: TFormSchema = {
    id: "form_ogaUsrSrch",
    schema: {
        orgCd: { type: "code", label: "L_ORG_CD", area: "orgCd", popupSize: "md" },
        deptCd: { type: "select", label: "L_DEPT_CD" },
        usrNm: { type: "text", label: "L_USR_NM" },
        usrIdntfNo: { type: "text", label: "L_TIN" },
    },
};

export const SF_ROLE_SRCH: TFormSchema = {
    id: "form_roleSrch",
    schema: {
        usrIdntfId: { type: "text" },
        roleId: { type: "text", label: "L_ROLE_ID" },
        roleNm: { type: "text", label: "L_ROLE_NM" },
    },
};

export const SG_OGA_USR_LIST: TGridSchema = {
    id: "grid_ogaUsrList",
    options: { index: true, pagination: "out" },
    head: [
        { cells: [{ header: "L_OGA_CD", binding: "orgCd", width: "15%" }] },
        { cells: [{ header: "L_OGA_NM", binding: "orgNm", width: "20%" }] },
        { cells: [{ header: "L_OGA_DEPT_NM", binding: "deptNm", width: "*" }] },
        { cells: [{ header: "L_TIN", binding: "usrIdntfNo", width: "15%" }] },
        { cells: [{ header: "L_USR_NM", binding: "usrNm", width: "20%" }] },
        { cells: [{ header: "L_USR_STAT_CD", binding: "usrStatCd", width: "10%" }] },
    ],
    body: [
        { cells: [{ binding: "orgCd", align: "center" }] },
        { cells: [{ binding: "orgNm", align: "left" }] },
        { cells: [{ binding: "deptNm", align: "left" }] },
        { cells: [{ binding: "usrIdntfNo", align: "center" }] },
        { cells: [{ binding: "usrNm", align: "left" }] },
        { cells: [{ binding: "usrStatCd", type: "code", area: "comnCd", comnCd: "OSC0156", align: "center" }] },
    ],
};

export const SF_OGA_USR_INFO: TFormSchema = {
    id: "form_ogaUsrInfo",
    schema: {
        psnTin: { type: "text", label: "L_TIN", edit: false },
        orgCd: { type: "code", label: "L_ORG_CD", area: "orgCd", popupSize: "md", edit: false },
        frgnrYn: {
            type: "radio",
            label: "L_FRGNR_YN",
            options: [
                { label: "Citizen", value: "N" },
                { label: "Foreigner", value: "Y" },
            ],
            defaultValue: "N",
            edit: false,
            // required: true,
        },
        aplcCntyCd: { type: "code", label: "L_APLC_CNTY_CD", area: "cntyCd", popupSize: "md", edit: false },
        usrNm: { type: "text", label: "L_USR_NM", edit: false },
        usrMoblNo: { type: "text", label: "L_USR_MOBL_NO", edit: false },
        usrEmlAddr: {
            type: "text",
            label: "L_USR_EML_ADDR",
            pattern: { value: /[a-z0-9]+@[a-z]+.[a-z]{2,3}/, message: "msg.osc.00101" },
            edit: false,
        },
        rsdtAddr: { type: "text", label: "L_RSDT_ADDR", edit: false },
        usrPwd: {
            type: "password",
            label: "L_USR_PWD",
            edit: false,
            pattern: {
                value: /^(?=.*[A-Z])(?=.*[a-z])(?=.*\d)(?=.*[\W_])[A-Za-z\d\W_]{10,}$/,
                message: "비밀번호는 10자 이상이어야 하며, 대문자, 소문자, 숫자, 특수문자를 포함해야 합니다",
            },
        },
        usrPwdCfrm: { type: "password", label: "L_USR_PWD_CFRM", edit: false },
        prevUsrAplyId: { type: "text" },
        usrStatCd: { type: "select", label: "L_STAT", all: false, area: "comnCd", comnCd: "OSC0156", edit: false },
        deptCd: { type: "code", label: "L_ORG_DEPT", area: "orgDeptCd", popupSize: "md", edit: false },
        orgRppnYn: {
            type: "radio",
            label: "L_ORG_RPPN_YN",
            options: [
                { label: "Head of Organization", value: "Y" },
                { label: "General", value: "N" },
            ],
            edit: false,
        },
        mdfyRsn: { type: "textarea", label: "L_MDFY_RSN", controlSize: 10, rows: 5, maxLength: 2000, edit: false },
        cstmOfceCd: {
            label: "L_CSTM_OFCE_CD",
            type: "code",
            area: "cstmCd",
            popupSize: "md",
            popupParams: {
                // dclrYn: "Y",
            },
            edit: false,
        },
    },
};

export const SF_ROLE_FILE_FORM: TFormSchema = {
    id: "form_roleFileForm",
    schema: {
        fileGrpUuid: {
            type: "file",
            multiple: false,
            controlSize: 10,
            disableName: true,
            disableDescription: true,
            disableTitle: true,
            isPublic: true,
            required: true,
        },
    },
};

export const SG_OGA_USR_ROLE_LIST: TGridSchema = {
    id: "grid_ogaUsrRoleList",
    options: { checkbox: true, pagination: "in" },
    head: [
        { cells: [{ header: "L_ROLE_ID", binding: "roleId", width: 150 }] },
        { cells: [{ header: "L_ROLE_NM", binding: "roleNm", width: "*" }] },
        { cells: [{ header: "L_ROLE_DESC", binding: "roleDesc", width: "*" }] },
        { cells: [{ header: "Attached File", binding: "attchFle", width: "*" }] },
    ],
    body: [
        { cells: [{ binding: "roleId", align: "center" }] },
        { cells: [{ binding: "roleNm", align: "center" }] },
        { cells: [{ binding: "roleDesc", align: "center" }] },
        { cells: [{ binding: "attchFle", align: "center" }] },
    ],
};

export const SG_SCRH_ROLE_LIST: TGridSchema = {
    id: "grid_srchRoleList",
    options: { checkbox: true, pagination: "in" },
    head: [
        { cells: [{ header: "L_ROLE_ID", binding: "roleId", width: "*" }] },
        { cells: [{ header: "L_ROLE_NM", binding: "roleNm", width: "*" }] },
        { cells: [{ header: "L_ROLE_DESC", binding: "roleDesc", width: "*" }] },
        { cells: [{ binding: "isRgsrYn", width: "*" }], show: false },
    ],
    body: [
        { cells: [{ binding: "roleId", align: "center" }] },
        { cells: [{ binding: "roleNm", align: "left" }] },
        { cells: [{ binding: "roleDesc", align: "center" }] },
        { cells: [{ binding: "isRgsrYn", align: "center" }] },
    ],
};

export const SG_OGA_USR_EXCEL_LIST: TGridSchema = {
    id: "grid_OgaUsrExcelList",
    options: { index: true, pagination: "out" },
    head: [
        { cells: [{ header: "L_OGA_CD", binding: "orgCd", width: "15%" }] },
        { cells: [{ header: "L_OGA_NM", binding: "orgNm", width: "20%" }] },
        { cells: [{ header: "L_OGA_DEPT_NM", binding: "deptNm", width: "*" }] },
        { cells: [{ header: "L_TIN", binding: "usrIdntfNo", width: "15%" }] },
        { cells: [{ header: "L_USR_NM", binding: "usrNm", width: "20%" }] },
        { cells: [{ header: "L_USR_STAT_CD", binding: "usrStatCd", width: "10%" }] },
    ],
    body: [
        { cells: [{ binding: "orgCd", align: "center" }] },
        { cells: [{ binding: "orgNm", align: "left" }] },
        { cells: [{ binding: "deptNm", align: "left" }] },
        { cells: [{ binding: "usrIdntfNo", align: "center" }] },
        { cells: [{ binding: "usrNm", align: "left" }] },
        { cells: [{ binding: "usrStatCd", type: "code", area: "comnCd", comnCd: "OSC0156", align: "center" }] },
    ],
};
